
import React from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import MonthGrid from './MonthGrid';

const ReformCalendarPage = () => {
  document.title = "Takvim | Reform Panel";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Takvim" pageTitle="Reform Panel" />
          <MonthGrid />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReformCalendarPage;